import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { integrationToName } from 'components/IntegrationRequiredModal/IntegrationRequiredModal'
import Styles from './ManageIntegrationAccounts.module.scss'
import { Heading } from 'almanac-ui/Heading/Heading'
import { UserProfileAdd } from 'blaze-ui/icons'
import { useTierUsageLimits } from 'hooks/useTierUsageLimits'
import { PricePill } from 'blaze-ui/Pricing/PricePill/PricePill'
import { useModals } from 'almanac-ui/Modal'
import { TierUpgradeModal } from 'components/TierUpgradeModal/TierUpgradeModal'
import { capitalize } from 'lodash'
export const AddNewAccountCard = ({
  provider,
  onPress,
}: {
  provider: ExternalIntegrationEnum
  onPress: () => void
}) => {
  const name = integrationToName[provider]
  const { openModal } = useModals()
  const { atLimit, nextTierPlan, currentTierPlan } = useTierUsageLimits({
    limitKey: 'integrations',
    integrationType: provider,
  })

  const shouldEnforceLimit = atLimit && nextTierPlan && currentTierPlan

  const handleLimitWrappedPress = () => {
    if (shouldEnforceLimit) {
      openModal(TierUpgradeModal, {
        reason: 'limit_reached',
        feature: `${capitalize(provider)} Integrations`,
        upgradeTier: nextTierPlan,
        currentTier: currentTierPlan,
        onUpgrade: onPress,
      })
    } else {
      onPress()
    }
  }

  return (
    <div className={Styles.addNewAccountCard} onClick={handleLimitWrappedPress}>
      {shouldEnforceLimit && (
        <div className={Styles.pricePillContainer}>
          <PricePill plan={nextTierPlan.key} />
        </div>
      )}
      <UserProfileAdd size={30} />
      <Heading level={4} color="var(--dark-80)">
        Connect Another {name} Account
      </Heading>
    </div>
  )
}
